// extracted by mini-css-extract-plugin
module.exports = {"spinnerLoader":"SpinerLoader_spinnerLoader__ZW3ya","spin":"SpinerLoader_spin__1_III"};